import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

document.documentElement.dataset.theme = localStorage.getItem('theme') || 'dark';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
